import { API_BASE_URL, getAuthToken, getJsonHeaders, checkAndHandleTokenExpiration } from './api';

/**
 * Run Stripe event sync using the stored checkpoint (same window the
 * scheduled job uses). Good for routine on-demand catch-up.
 */
export const runStripeSync = async () => {
  try {
    checkAndHandleTokenExpiration();

    const response = await fetch(`${API_BASE_URL}/admin/stripe-sync/run`, {
      method: 'POST',
      headers: getJsonHeaders(getAuthToken()),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || errorData.error || 'Failed to run Stripe sync');
    }

    return await response.json();
  } catch (error) {
    console.error('Error running Stripe sync:', error);
    throw error;
  }
};

/**
 * Run Stripe event sync from an explicit point in time — use after a
 * known outage to sweep exactly the affected window.
 * @param {string} sinceIso - ISO-8601 local date-time, e.g. "2026-08-15T09:00:00"
 */
export const runStripeSyncFrom = async (sinceIso) => {
  try {
    checkAndHandleTokenExpiration();

    const url = `${API_BASE_URL}/admin/stripe-sync/run-from?since=${encodeURIComponent(sinceIso)}`;
    const response = await fetch(url, {
      method: 'POST',
      headers: getJsonHeaders(getAuthToken()),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || errorData.error || 'Failed to run Stripe sync from timestamp');
    }

    return await response.json();
  } catch (error) {
    console.error('Error running Stripe sync from timestamp:', error);
    throw error;
  }
};